"use client";
import { BettingTrending } from "@fanduel/formation-react-icons";
import { CardHeader } from "@/components/headToHead/Card";
import TabsPagination from "@/components/TabsPagination";
import useScrollRefs from "@/utils/hooks/useScrollRefs";
import { filterEmpty } from "@/utils/index";
import { EmptyMessage } from "../../PlayerStats/PlayerProps/oddsUnavailable/OddsUnavailable";
import PopularBetsDisplay from "./PopularBetsDisplay";
import type { PreferredOrder } from "../../types";
import styles from "./popularBets.module.scss";

export interface PopularBetsProps {
  parlays: PreferredOrder;
}

export default function PopularBets({ parlays }: PopularBetsProps) {
  const {
    disableScrollMinus,
    disableScrollPlus,
    removeOffset,
    addOffset,
    containerRef,
    scrollUpdate,
    scrollRef,
  } = useScrollRefs(310, undefined, true);
  // filter for only multileg parlays
  const multiLegParlays = filterEmpty(parlays).filter(
    (parlay) =>
      parlay.americanOdds &&
      parlay.events?.[0]?.selections != null &&
      parlay.events[0].selections.length > 1
  );

  return (
    <>
      <CardHeader
        icon={<BettingTrending width={17} height={17} />}
        title="Popular Bets"
        action={
          <TabsPagination
            addOffset={addOffset}
            removeOffset={removeOffset}
            disableScrollPlus={disableScrollPlus}
            disableScrollMinus={disableScrollMinus}
          />
        }
      />
      {!(multiLegParlays.length > 0) ? (
        <EmptyMessage className={styles.emptyMessage} />
      ) : null}
      <PopularBetsDisplay
        scrollUpdate={scrollUpdate}
        containerRef={containerRef}
        scrollRef={scrollRef}
        parlays={multiLegParlays}
      />
    </>
  );
}
